import { render } from "./app-format-unit.vue?vue&type=template&id=5fb31d60&ts=true"
import script from "./app-format-unit.vue?vue&type=script&lang=ts"
export * from "./app-format-unit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__